import React from 'react';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';

import SelectField from '../common/components/SelectField';

type Props = {
  filterStartYear: number;
  year: string;
  setYear: (year: string) => void;
};

function DocumentationFilter({ filterStartYear, year, setYear }: Props) {
  const currentYear = new Date().getFullYear();
  const yearDifference = currentYear - filterStartYear >= 0 ? currentYear - filterStartYear : 0;

  const years = new Array(yearDifference + 1).fill(0).map((_, index) => {
    const test = currentYear - index;
    return { label: `${test}`, value: `${test}` };
  });

  return (
    <Paper
      variant='outlined'
      sx={{
        display: 'flex',
        flexDirection: 'column',
        margin: '0 0 32px 0',
        padding: '20px 24px',
        minWidth: '300px',
        maxWidth: '650px',
        backgroundColor: '#FAFAFA',
      }}
    >
      <Grid container rowSpacing={2} columnSpacing={4}>
        <Grid item xs={6}>
          <SelectField
            label='Jahr'
            options={years}
            value={year}
            fullWidth
            handleChange={(value: unknown) => {
              if (typeof value === 'string') {
                setYear(value);
              }
            }}
          />
        </Grid>
      </Grid>
    </Paper>
  );
}

export default DocumentationFilter;
